import { render, staticRenderFns } from "./SliderV12.vue?vue&type=template&id=5e7e03ec&"
import script from "./SliderV12.vue?vue&type=script&lang=js&"
export * from "./SliderV12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports